import { Controller, useForm } from 'react-hook-form'
import { SearchResult, SearchDescriptionFormData } from 'interface/search'
import { MarkdownInput } from 'components/controls/markDownInput'

export const useSearchsDescriptionForm = (
  search: SearchResult
) => {
  return {
    search,
    form: useForm<SearchDescriptionFormData>({
      defaultValues: {
        description: search.description ?? ''
      }
    })
  }
}

export const SearchsDescriptionForm = ({
  form: {
    control,
    formState: { errors }
  }
}: ReturnType<typeof useSearchsDescriptionForm>) => (
  <Controller
    control={control}
    name="description"
    render={({ field }) => (
      <MarkdownInput
        {...field}
        rows={20}
        error={!!errors.description}
        helperText={errors.description ? errors.description.message : ''}
      />
    )}
  />
)
